import EventBus from './../wirebox/event-bus'
import jQuery from 'jquery'
import '@chenfengyuan/datepicker'
import './../wirebox/utilities/input-type-support'
import './../wirebox/utilities/touch-device/detection'
import './../wirebox/components/cached-script'

class DatepickerComponent {
    
    /**
     * Construct module
     * @param inputs
    */
    constructor(inputs) {
        
        /**
         * Datepicker inputs
         * @type object
        */
        this.inputs = inputs
        
        /**
         * Whether datetime inputs are natively supported
         * @type {boolean}
        */
        this.dateSupport = false
        
        /**
         * Whether the user is on a touch device
         * @type {boolean}
        */
        this.isTouchDevice = false
        
        /**
         * Whether custom datepickers are being used
         * @type {boolean}
        */
        this.hasCustomDatepickers = false
        
        /**
         * Original options parameters for custom datepicker
         * @type {object}
        */
        this.options = {
            autoHide: true,
            format: 'yyyy-mm-dd'
        }
        
        //Apply locale to options
        if (typeof datepickerLocale !== 'undefined') {
            this.options.locale = datepickerLocale + '-' + datepickerLocale.toUpperCase()
        }
        
        this.bindEvents()
        
    }
    
    /**
     * Run module
    */
    run() {
        
        //Determine whether native datepickers should be used
        this.hasCustomDatepickers = !this.dateSupport || (navigator.userAgent.indexOf('Chrome') > -1 && !this.isTouchDevice)
        
        //Apply native datepickers
        if (!this.hasCustomDatepickers) {
            
            this.inputs.each((i, elem) => {
                jQuery(elem).prop('type', 'date').prop('autocomplete', '')
            })
            
            return
            
        }
        
        //Apply localisation to datepicker
        if (typeof datepickerLocaleFile !== 'undefined') {

            jQuery.cachedScript(datepickerLocaleFile, {
                complete: this.initDatepickers.bind(this)
            })
            
            return
            
        }
        
        //Apply datepickers to elements
        this.initDatepickers()
        
    }
    
    /**
     * Handle date support
     * @param hash
    */
    handleDateSupport(hash) {
        this.dateSupport = hash.date
    }
    
    /**
     * Set that this is on a touch device
    */
    setTouchDevice() {
        this.isTouchDevice = true
    }
    
    /**
     * Initialise datepickers
    */
    initDatepickers() {
        
        const time = Math.floor(Date.now() / 1000)
        
        this.inputs.each((i, element) => {
            this.applyDatepicker(jQuery(element).prop('autocomplete', ('off-' + time)))
        })
        
    }
    
    /**
     * Apply custom datepicker to input
     * @param input
    */
    applyDatepicker(input) {
        
        let options = jQuery.extend({}, this.options)
        
        //Max date if value is present
        let max = input.attr('max')
        if (max) {
            options.date = new Date(max)
        }
        
        //Z-index
        let zIndex = input.data('z-index')
        if (zIndex) {
            options.zIndex = zIndex
        }
        
        input.datepicker(options)
        
    }
  
    /**
     * Bind event listeners
    */
    bindEvents() {
        
        //Run module
        EventBus.subscribe('run-modules', this.run.bind(this))
        
        //Date support
        EventBus.subscribe('input-support-checked', this.handleDateSupport.bind(this))
        
        //Touch Device
        EventBus.subscribe('isTouchDevice', this.setTouchDevice.bind(this))
      
    }
  
}

EventBus.subscribe('init-modules',  () => {
    
    let inputs = jQuery('.input-datepicker')
    
    if (inputs.length > 0) {
        new DatepickerComponent(inputs)
    }
    
})

export default DatepickerComponent